import React from "react";
import { Box } from "@mui/material";
import HistoryTable from "./HistoryTable";
import { useAlarmsHistory } from "../../../../hooks/useReduxSelectors";

const AlarmsHistory = ({ alarmsPageId }) => {
  const alarmsHistory = useAlarmsHistory();
  const allAlarms = alarmsHistory?.entries;
  let list = allAlarms;
  switch (alarmsPageId) {
    case "all": {
      list = allAlarms;
      break;
    }
    case "warnings": {
      list = (allAlarms || []).filter((item) => item.category === "Warning");
      break;
    }
    case "device": {
      list = (allAlarms || []).filter((item) => item.category === "Device");
      break;
    }
    case "sample": {
      list = (allAlarms || []).filter((item) => item.category === "SampleCondition");
      break;
    }
    default: {
      list = [];
      break;
    }
  }
  return (
    <Box sx={{ height: "100%", overflow: "auto", borderRadius: "3px" }}>
      <Box sx={{ overflow: "auto", minHeight: 0, width: "100%", mt: "30px" }}>
        {(alarmsPageId === "all" ||
          alarmsPageId === "device" ||
          alarmsPageId === "sample" ||
          alarmsPageId === "warnings") && (
            <HistoryTable
              alarmsPageId={alarmsPageId}
              alarmsList={list}
            />
          )}
      </Box>
    </Box>
  );
};



export default AlarmsHistory;
